import React, { FC, Suspense } from 'react';
import { Layout } from 'antd';
import { Switch, Route } from 'react-router-dom';
import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';
import UserPage from '../UserPage/UserPage';
import PersonalArea from '../PersonalArea/PersonalArea';
import RegisterPage from '../PersonalArea/RegisterPage';
import RestorePage from '../PersonalArea/RestorePage';

const { Content } = Layout;

const MainSlider = React.lazy(() => import('../MainBox/MainBox'));
const YandexMap = React.lazy(() => import('../YandexMap/YandexMap'));
const About = React.lazy(() => import('../About/About'));
const CitizenMessage = React.lazy(
  () => import('../CitizenMessage/CitizenMessage')
);
const RestorePasswordPage = React.lazy(
  () => import('../PersonalArea/RestorePasswordPage')
);

const ContentBox: FC = () => {
  return (
    <Content>
      <div className="site-layout-content">
        <Suspense fallback={<LoaderSpinner />}>
          <Switch>
            <Route exact path="/">
              <MainSlider />
            </Route>
            <Route exact path="/map">
              <YandexMap />
            </Route>
            <Route exact path="/about">
              <About />
            </Route>
            <Route
              exact
              path="/citizen-message/:id"
              component={CitizenMessage}
            />
            <Route exact path="/login">
              <PersonalArea />
            </Route>
            <Route exact path="/restore">
              <RestorePage />
            </Route>
            <Route
              exact
              path="/restore_password/:hash"
              component={RestorePasswordPage}
            />
            <Route path="/personal-area" exact component={UserPage} />
            <Route exact path="/register">
              <RegisterPage />
            </Route>
          </Switch>
        </Suspense>
      </div>
    </Content>
  );
};

export default ContentBox;
